// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__MEuWj","table":"Table_table__kvG8V","row":"Table_row__2UP9d","col":"Table_col__QmrQV","status":"Table_status__NoSMJ"};